module.exports = __webpack_public_path__ + "img/second_appointment_text4.2533f3aa.png";